import React from "react";
import { Box, Typography } from "@mui/material";
import modelHeaderStyle from "./modelHeaderStyle";

const ModelHeader = () => {

    const classes = modelHeaderStyle();

    return (
        <Box className={classes.headerContainer}>

            <Typography variant="h4" className={classes.header}>
                Interactive Dual Viewers
            </Typography>

            <Typography variant="body1" className={classes.paragraph}>
                Explore our dual-viewer experience:
                the VC Publisher Viewer, featuring advanced analysis tools and plugins,
                and the IFC Viewer, which integrates detailed point clouds and LOD2 city models for an immersive, interactive experience.
            </Typography>

        </Box>
    );
};

export default ModelHeader;